import React from 'react';
import PropTypes from 'prop-types';

export const LearnMore = (props) => {
  const {
    i18n, topicId, ariaLabel, label,
  } = props;

  return (
    <React.Fragment>
      <span> </span>
      <button
        className="HelpTopic clickable btn-link"
        query={`help:${topicId}`}
        aria-label={ariaLabel}
      >
        {label || i18n.getString(_TL_('Learn more'))}
      </button>
    </React.Fragment>);
};

LearnMore.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  topicId: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  label: PropTypes.string,
};

LearnMore.defaultProps = {
  label: undefined,
};
